import TextInput from "../../../../Comon/TextInput/TextInput";
import React from "react";
export default function PersonalizationBoolean({
                                                 title = 'Title',
                                                 isChecked,
                                                 setIsChecked,
                                                 errorMessage = null,
}) {

    return <div>
        <div
            onClick={() => setIsChecked(!isChecked)}
            style={{
                display:'flex',
                gap:'10px',
                alignItems:'center',
                cursor:'pointer',
            }}
        >
            {
                isChecked ?
                    <img src={'/assets/checkbox_on.svg'}/>
                    :
                    <img src={'/assets/checkbox_off.svg'}/>
            }
            <span style={{
                color:'rgba(73, 73, 73, 1)',
            }}>{title}</span>
        </div>


        {
            errorMessage && (
                <div
                    style={{
                        color: 'red',
                        marginLeft: '29px',
                        fontSize: '12px',
                        marginTop: '5px',
                    }}
                >
                    {typeof errorMessage === 'string' ? (
                        <div>{errorMessage}</div>  // Render the errorMessage as a string
                    ) : (
                        errorMessage.map((item, index) => (
                            <div key={index}>{item}</div>  // Map over the array if it's an array
                        ))
                    )}
                </div>
            )
        }
    </div>

}
